var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymization({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#005A50",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1360 4278 c-18 -13 -42 -34 -52 -48 -13 -18 -55 -209 -145 -661 l-127 -637 -160 -32 c-251 -51 -615 -145 -644 -167 -50 -38 -67 -70 -67 -132 0 -73 33 -121 99 -146 54 -21 45 -22 316 48 396 102 775 170 1185 211 489 50 1098 50 1590 0 391 -39 806 -113 1185 -211 273 -70 254 -66 295 -59 48 9 112 73 121 120 17 95 -30 164 -134 196 -94 29 -441 113 -603 147 l-136 27 -126 635 c-90 454 -132 643 -145 661 -56 75 -125 87 -249 41 -43 -16 -127 -42 -188 -59 -583 -164 -1211 -147 -1787 48 -135 46 -181 50 -228 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274 2345 c-298 -65 -542 -320 -595 -619 -14 -86 -7 -260 16 -341 56 -206 213 -394 408 -490 212 -104 470 -102 682 5 253 127 425 397 425 668 l0 72 349 0 348 0 6 -97 c9 -167 59 -300 162 -431 224 -286 625 -375 950 -212 262 131 425 396 425 690 0 337 -211 627 -535 736 -97 32 -263 43 -371 25 -91 -16 -202 -61 -284 -116 -77 -51 -186 -162 -225 -229 l-27 -46 -448 0 -448 0 -27 46 c-39 67 -148 178 -224 228 -81 54 -173 93 -260 112 -82 17 -246 17 -327 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymization);
export default __webpack_public_path__ + "static/media/anonymization.681055a78678710b5a875a98e17f26e0.svg";
export { ForwardRef as ReactComponent };